module.exports = __webpack_public_path__ + "media/Icons/ico-info-79f72420.png";